// const baseUrl = 'http://localhost:5000'
// const baseUrl = 'https://estarch-server-presonal.onrender.com'
// const baseUrl = 'https://estarch-backend-vps.vercel.app'
const baseUrl = 'https://estarch-server-personal.vercel.app'
// const baseUrl = 'https://demo-backend.estarch.online'
// const baseUrl = 'https://api.v1.estarch.online'
// const baseUrl = 'https://api.showroom.estarch.com.bd'
export default baseUrl;